import { TagsButtonVariants } from "@foodpilot/foods";
import type { TFunction } from "i18next";

export type ActionStatus = {
    id: number;
    label: string;
    backendLabel: string | undefined;
    color: TagsButtonVariants;
    display: boolean;
};

export const getActionStatus = (t: TFunction): ActionStatus[] => [
    // This first item will not show :)
    {
        id: 0,
        backendLabel: "no-status",
        label: t("action_plan.status.no_status", "No status"),
        color: "tags-red",
        display: false,
    },
    {
        id: 1,
        backendLabel: "en réflexion",
        label: t("action_plan.status.planning", "Under consideration"),
        color: "tags-red",
        display: true,
    },
    {
        id: 2,
        backendLabel: "planifiée",
        label: t("action_plan.status.planned", "Planned"),
        color: "tags-grey",
        display: true,
    },
    {
        id: 3,
        backendLabel: "en cours",
        label: t("action_plan.status.in_progress", "In progress"),
        color: "tags-white",
        display: true,
    },
    {
        id: 4,
        backendLabel: "intégrée",
        label: t("action_plan.status.review", "Integrated"),
        color: "tags-black",
        display: true,
    },
    {
        id: 5,
        backendLabel: "terminée",
        label: t("action_plan.status.done", "Completed"),
        color: "tags-green",
        display: true,
    },
];
